require('./arrow.js');
var postCORS = require('./post-cors.js');
var AR = require('component/core/core.js');
var transliteration = require('transliteration.cyr');

var nameOrLogo = AR.title;
var buttonTitle = AR.locale({ru: 'Скачать XLS', en: 'Download XLS'});

/**
 * Отправить данные Xls на сервис генерации Xls
 * @param  {String} title     Заголовок таблицы
 * @param  {String} filename Имя будущего xls-файла
 * @param  {Object} data     HTML таблицы
 */
function sendXls(title, filename, data) {
	postCORS('http://arservices.3ebra.com/xls_gen/', {
		filename,
		title,
		logo: title,
		data
	});

	Arrow.show(5000);
}

function titleToFilename(title) {
	var re = /[\W_]+/g;
	var subst = '_';

	return transliteration.transliterate(title)
		.replace(re, subst)
		.slice(0, 256);
};

function getTableData($container, $table) {
	var title = $container.find('caption').text();
	return {
		title,
		filename: titleToFilename(title),
		html: $table[0].outerHTML
	};
}

function getChartData($container, $chart) {
	var chartData = global.zebraCharts.getChartAsTableHtml($chart.attr('id'));
	var $caption = $container.find('figcaption');
	var title = $caption.length ? $caption.text() : chartData.title;
	return {
		title,
		filename: titleToFilename(title),
		html: chartData.html
	};
}

$.fn.extend({
	/**
	 * Добавить кнопку скачивания Xls
	 */
	addExcelExport: function () {
		return this.each(function () {
			var $this = $(this);
			var $table = $this.find('table');
			var $chart = $this.find('.chart');
			if ($table.length) {
				var data = getTableData($this, $table);
			} else if ($chart.length) {
				var data = getChartData($this, $chart);
			}
			if (data && data.html) {
				$this.find('.js-buttons')
					.append(`<button class="button button--excel js-button-excel" title="${buttonTitle}">${buttonTitle}</button>`)
					.find('.js-button-excel')
					.on('click', function excelExport(event) {
						event.preventDefault();

						sendXls(data.title, data.filename, data.html);
						global.blurOnLeave(this);
					});
			}
		});
	}
});



/** WEBPACK FOOTER **
 ** ./frontend/components/excel-export/excel-export.js
 **/